<template>
    <main class="dm-page-container dm-flex-column dm-padding-0">
        <menu-header :showHero="true" />
        <div class="announcements-container" v-if="announcements.Display">
            <div class="announcements-content">
                <div class="announcements-text" v-html="announcements.Message"></div>
            </div>
        </div>
        <div class="no-announcements" v-else-if="!announcements.Display">
            <p>No announcements are currently available.</p>
        </div>
    </main>
</template>

<script>
import MenuHeader from '../../components/menuHeader.vue';
import adaMixin from "../../js/mixins/adaMixin.js";

export default {
    name: "announcements-page",
    mixins: [adaMixin],
    components: {
        'menu-header': MenuHeader
    },
    computed: {
        announcements() {
            return this.$store.state.PublicMenuModule.announcements
        },
    },
}
</script>

<style scoped>
.announcements-container {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
}

.no-announcements {
    height: 200px;
    width: calc(100% - 40px);
    border: 1px solid #e0e0e0;
    margin: 0 20px 20px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    color: #666;
}

@media (max-width: 768px) {
    .announcements-container {
        padding: 15px;
    }
}
</style>

<style>
/* Quill Editor Content Styles */
.announcements-text .ql-size-small {
    font-size: 0.75em;
}

.announcements-text .ql-size-large {
    font-size: 1.5em;
}

.announcements-text .ql-size-huge {
    font-size: 2.5em;
}

.announcements-text .ql-font-serif {
    font-family: Georgia, Times New Roman, serif;
}

.announcements-text .ql-font-monospace {
    font-family: Monaco, Courier New, monospace;
}

.announcements-text .ql-align-center {
    text-align: center;
}

.announcements-text .ql-align-right {
    text-align: right;
}

.announcements-text .ql-align-justify {
    text-align: justify;
}

.announcements-text .ql-indent-1 {
    padding-left: 3em;
}

.announcements-text .ql-indent-2 {
    padding-left: 6em;
}

.announcements-text .ql-indent-3 {
    padding-left: 9em;
}

.announcements-text .ql-indent-4 {
    padding-left: 12em;
}

.announcements-text .ql-indent-5 {
    padding-left: 15em;
}

.announcements-text .ql-indent-6 {
    padding-left: 18em;
}

.announcements-text .ql-indent-7 {
    padding-left: 21em;
}

.announcements-text .ql-indent-8 {
    padding-left: 24em;
}

.announcements-text h1,
.announcements-text h2,
.announcements-text h3,
.announcements-text h4,
.announcements-text h5,
.announcements-text h6 {
    margin: 0;
    margin-bottom: 0.5em;
}

.announcements-text p {
    margin: 0;
    margin-bottom: 1em;
}

.announcements-text ol,
.announcements-text ul {
    padding-left: 1.5em;
    margin: 0 0 1em 0;
    list-style-position: outside;
}

.announcements-text ul {
    list-style-type: disc !important;
}

.announcements-text ol {
    list-style-type: decimal !important;
}

.announcements-text li {
    margin-bottom: 0.5em;
    display: list-item !important;
    list-style-type: inherit !important;
}

.announcements-text ul li {
    list-style-type: disc !important;
}

.announcements-text ol li {
    list-style-type: decimal !important;
}

/* Nested list styles */
.announcements-text ul ul {
    list-style-type: circle !important;
}

.announcements-text ul ul li {
    list-style-type: circle !important;
}

.announcements-text ul ul ul {
    list-style-type: square !important;
}

.announcements-text ul ul ul li {
    list-style-type: square !important;
}

.announcements-text ol ol {
    list-style-type: lower-alpha !important;
}

.announcements-text ol ol li {
    list-style-type: lower-alpha !important;
}

.announcements-text ol ol ol {
    list-style-type: lower-roman !important;
}

.announcements-text ol ol ol li {
    list-style-type: lower-roman !important;
}

.announcements-text blockquote {
    border-left: 4px solid #ccc;
    margin: 0;
    margin-bottom: 1em;
    padding-left: 16px;
}

.announcements-text code {
    background-color: #f0f0f0;
    border-radius: 3px;
    padding: 2px 4px;
    font-size: 85%;
}

.announcements-text pre {
    background-color: #f0f0f0;
    border-radius: 3px;
    padding: 10px;
    margin-bottom: 1em;
    overflow: auto;
}

.announcements-text pre code {
    background-color: transparent;
    padding: 0;
}

.announcements-text img {
    max-width: 100%;
    height: auto;
}

.announcements-text a {
    color: #06c;
}

.announcements-text strong {
    font-weight: bold;
}

.announcements-text em {
    font-style: italic;
}

.announcements-text s {
    text-decoration: line-through;
}

.announcements-text u {
    text-decoration: underline;
}

/* Quill specific color classes */
.announcements-text .ql-color-red { color: #e60000; }
.announcements-text .ql-color-orange { color: #f90; }
.announcements-text .ql-color-yellow { color: #ff0; }
.announcements-text .ql-color-green { color: #008a00; }
.announcements-text .ql-color-blue { color: #06c; }
.announcements-text .ql-color-purple { color: #93f; }

.announcements-text .ql-bg-red { background-color: #e60000; }
.announcements-text .ql-bg-orange { background-color: #f90; }
.announcements-text .ql-bg-yellow { background-color: #ff0; }
.announcements-text .ql-bg-green { background-color: #008a00; }
.announcements-text .ql-bg-blue { background-color: #06c; }
.announcements-text .ql-bg-purple { background-color: #93f; }
</style>